"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchApp = void 0;
var tslib_1 = require("tslib");
var web_base_1 = require("@tencent/web-base");
var enum_1 = require("../../enum");
var jump_scheme_1 = require("./jump-scheme");
var init_aegis_1 = tslib_1.__importDefault(require("../../_util/init-aegis"));
var launchAppStartTime;
var checkLaunchIdCount = 0;
/**
 * 是否通过jsapi唤起判断
 * saas企业微信中 & 不是腾讯的企业 & 不是特邀二维码唤起 => 通过jsapi唤起
 * @param {*} meetingType 会议类型
 * @param {*} launchMode 特邀唤起模式0-普通或无效 1-小程序 2-二维码
 * @param {*} isWxWorkSaas Saas企业微信（非私有化企业微信）服务端方法
 */
var isJsApiLaunch = function (meetingType, launchMode, isWxWorkSaas) {
    var corpId = (0, web_base_1.getCookie)('wework_corp_id');
    var fromQrCode = false;
    if (meetingType === enum_1.EnumMeetingType.SpeciallyInvitedMeeting && launchMode === enum_1.EnumLaunchMode.QrCode) {
        fromQrCode = true;
    }
    return isWxWorkSaas() && corpId && corpId !== enum_1.TX_CORP_ID && !fromQrCode;
};
/**
 * scheme唤起场景
 * 适配微信 & 企业微信特邀二维码唤起的scheme跳转
 * @param {EnumSchemeUrl} schemeUrl
 * @param {Function} jumpCallback 发起唤起之后的回调
 * @param {BeaconReport} reportCallback 灯塔上报回调
 * @param {WxLaunchFailedCallback} wxLaunchFailedCallback 微信唤起失败回调函数
 */
var schemeLaunch = function (schemeUrl, jumpCallback, reportCallback) { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
    return [2 /*return*/, (0, jump_scheme_1.jumpScheme)(schemeUrl, !!window.debugMode, jumpCallback, reportCallback)];
}); }); };
/**
 * saas企业微信中 & 不是腾讯的企业 & 不是特邀二维码唤起
 * @param {EnumSchemeUrl} schemeUrl
 * @param {*} failCallback
 */
var invokeLaunchApp = function (schemeUrl, failCallback) {
    var _a, _b;
    var originUrl = schemeUrl;
    var newSchemeUrl = schemeUrl;
    if ((0, web_base_1.isTestEnv)()) {
        newSchemeUrl = newSchemeUrl.replace('wemeet', 'wwauth3rd3a82ac41e00d815d');
        // newSchemeUrl = newSchemeUrl.replace('wemeet', 'wwauth3rd4806d2ddf553eb8b');
        console.log('>>>invokeLaunchApp test url', newSchemeUrl);
    }
    if ((0, web_base_1.isPreReleaseEnv)()) {
        newSchemeUrl = newSchemeUrl.replace('wemeet', 'wwauth3rd4806d2ddf553eb8b');
        // newSchemeUrl = newSchemeUrl.replace('wemeet', 'wwauth3rd3a82ac41e00d815d');
        console.log('>>>invokeLaunchApp prerelease url', newSchemeUrl);
    }
    newSchemeUrl = newSchemeUrl.replace('wemeet', 'wwauth3rdca2b0d866939bfde');
    newSchemeUrl = (0, web_base_1.addURLSearch)(newSchemeUrl, { platformId: 'wxwork' });
    console.log('>>>invokeLaunchApp schemeUrl', newSchemeUrl);
    console.log('>>>invokeLaunchApp window.wx', (_a = window === null || window === void 0 ? void 0 : window.wx) === null || _a === void 0 ? void 0 : _a.invoke);
    (_b = window === null || window === void 0 ? void 0 : window.wx) === null || _b === void 0 ? void 0 : _b.invoke('launchApplication', {
        schema: newSchemeUrl,
    }, function (res1) {
        console.log('launchApplication res1', res1);
        if (res1.err_msg === 'launchApplication:ok') {
            init_aegis_1.default.logAll('[met-component-launchapp]launchApplication success', res1);
            return;
        }
        init_aegis_1.default.logAll('[met-component-launchapp]launchApplication failted!!', res1);
        if ((0, web_base_1.isMobile)()) {
            typeof failCallback === 'function' && failCallback();
            return;
        }
        originUrl = (0, web_base_1.addURLSearch)(originUrl, { platformId: 'wxwork' });
        // 不在手机微信中，所以不需要失败回调函数
        schemeLaunch(originUrl);
    });
};
/**
 * jsapi唤起场景
 * @param {EnumSchemeUrl} schemeUrl
 * @param {LaunchFailedCallback} failCallback Saas企业微信唤起失败回调函数
 */
var jsApiLaunch = function (schemeUrl, failCallback) {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.wx) === null || _a === void 0 ? void 0 : _a.checkJsApi({
        jsApiList: ['launchApplication'],
        success: function (res) {
            if (res.errMsg === 'checkJsApi:ok' && res.checkResult.launchApplication) {
                console.log('>>> checkJsApi launchApplication success');
                invokeLaunchApp(schemeUrl, failCallback);
                return;
            }
            init_aegis_1.default.logAll("[met-component-launchapp]checkJsApi failed!! schemeUrl: ".concat(schemeUrl), res);
            typeof failCallback === 'function' && failCallback();
        },
        fail: function () {
            console.log('>>> checkJsApi launchApplication fail');
            init_aegis_1.default.logAll("[met-component-launchapp]checkJsApi failed!! schemeUrl: ".concat(schemeUrl));
            typeof failCallback === 'function' && failCallback();
        },
    });
};
var createLaunchId = function (launchId, http) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var res;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, http.post(enum_1.HttpPrefix.WEMEET_WEB_API, '/v2/wemeet/service/create-launch-id', {
                    id: launchId,
                })];
            case 1:
                res = _a.sent();
                console.log('create-launch-id res:', res);
                return [2 /*return*/];
        }
    });
}); };
var checkLaunchId = function (launchId, cb, http, queryLaunchTimeout) {
    http.get(enum_1.HttpPrefix.WEMEET_WEB_API, '/v2/wemeet/service/query-launch-id', { id: launchId }).then(function (res) {
        console.debug('query launch id res:', res);
        checkLaunchIdCount += 1;
        if ((res === null || res === void 0 ? void 0 : res.value) === 1) { // 唤起成功
            cb === null || cb === void 0 ? void 0 : cb.success(launchAppStartTime);
        }
        else {
            // keep asking
            var ms = 1000;
            if (queryLaunchTimeout) {
                var _a = queryLaunchTimeout.timeoutCount, timeoutCount = _a === void 0 ? 3 : _a, timeoutCallback = queryLaunchTimeout.timeoutCallback;
                if (checkLaunchIdCount === timeoutCount) {
                    timeoutCallback === null || timeoutCallback === void 0 ? void 0 : timeoutCallback();
                }
            }
            if (checkLaunchIdCount > 20) {
                ms = 2000;
            }
            if (checkLaunchIdCount === 20) { // 唤起失败
                cb === null || cb === void 0 ? void 0 : cb.fail(launchAppStartTime);
            }
            if (checkLaunchIdCount < 40) {
                setTimeout(function () {
                    checkLaunchId(launchId, cb, http, queryLaunchTimeout);
                }, ms);
            }
        }
    });
};
/**
 * 唤起腾讯会议app入口
 *
 * 1. 海外企业微信链接唤起
 *
 * 2. jsapi唤起
 *
 *  （平台）saas企业微信，（企业）非腾讯，（链接）除特邀二维码all
 *
 * 3. scheme跳转唤起
 *
 *  （平台）saas企业微信，（企业）非腾讯，（链接）特邀二维码链接
 *
 *  （平台）saas企业微信，（企业）腾讯，（链接）all
 *
 *  （平台）私有化企业微信，（企业）all，（链接）all
 *
 *  （平台）非企业微信，（企业）all，（链接）all
 *
 * @param {*} initRes 初始化结果promise
 * @param {*} isVoov 是否海外企业微信
 * @param {*} schemeUrl 唤起链接
 * @param {*} launchId 业务可通过randomString(16)方法生成
 * @param {*} meetingType 会议类型，默认普通会议
 * @param {*} launchMode 0或者没有，普通会议；1，特邀会议小程序，2. 特邀会议扫毛，默认0
 * @param {*} defaultLogic 调用方定制容错逻辑（fail-调用出错回调，jumpCallback-微信版本过低提示回调, reportCallback-shcema跳转灯塔上报）
 * @param {*} launchCallback 唤起app之后回调逻辑（success-成功回调，fail-失败回调）
 * @param {*} returnJsApiStat 是否返回jsapi调用状态
 * @param {*} jsApiFailCb jsApi执行失败回调
 * @param {*} isWxWorkSaas Saas企业微信（非私有化企业微信）服务端方法
 * @param {WxLaunchFailedCallback} wxLaunchFailedCallback 微信唤起失败回调函数
 */
var launchApp = function (params) {
    var initLaunchRes = params.initLaunchRes, isVoov = params.isVoov, launchId = params.launchId, _a = params.meetingType, meetingType = _a === void 0 ? enum_1.EnumMeetingType.NormalMeeting : _a, _b = params.launchMode, launchMode = _b === void 0 ? enum_1.EnumLaunchMode.NotValid : _b, defaultLogic = params.defaultLogic, launchCallback = params.launchCallback, _c = params.returnJsApiStat, returnJsApiStat = _c === void 0 ? false : _c, jsApiFailCb = params.jsApiFailCb, isWxWorkSaas = params.isWxWorkSaas, http = params.http, queryLaunchTimeout = params.queryLaunchTimeout, rs = params.rs;
    var schemeUrl = params.schemeUrl;
    // voov meeting 唤起转发至tecent.com
    if (isVoov) {
        schemeUrl = "https://meeting.tencent.com/df/en/launch-app.html".concat((0, web_base_1.filterXss)(window.location.search));
        if ((0, web_base_1.isTestEnv)()) {
            schemeUrl = "https://test.txmeeting.tencent.com/df/en/launch-app.html".concat((0, web_base_1.filterXss)(window.location.search));
        }
        window.location.href = schemeUrl;
        return;
    }
    if (!schemeUrl.includes('launch_id')) {
        schemeUrl = (0, web_base_1.addURLSearch)(schemeUrl, { launch_id: launchId });
    }
    if (rs && !schemeUrl.includes('rs')) {
        schemeUrl = (0, web_base_1.addURLSearch)(schemeUrl, { rs: rs });
    }
    if (isJsApiLaunch(meetingType, launchMode, isWxWorkSaas)) {
        console.log('>>> jsApiLaunch');
        init_aegis_1.default.logAll('[met-component-launchapp]jsApiLaunch', schemeUrl);
        initLaunchRes && jsApiLaunch(schemeUrl, defaultLogic.fail);
        return;
    }
    if (isWxWorkSaas() && returnJsApiStat) {
        console.log('>>> returnJsApiStat true');
        jsApiFailCb === null || jsApiFailCb === void 0 ? void 0 : jsApiFailCb();
        return;
    }
    console.log('>>> schemeLaunch');
    init_aegis_1.default.logAll('[met-component-launchapp]schemeLaunch', schemeUrl);
    schemeLaunch(schemeUrl, defaultLogic.jumpCallback, defaultLogic.reportCallback);
    launchAppStartTime = new Date();
    createLaunchId(launchId, http);
    setTimeout(function () {
        checkLaunchIdCount = 0;
        checkLaunchId(launchId, launchCallback, http, queryLaunchTimeout);
    }, 1000);
};
exports.launchApp = launchApp;
//# sourceMappingURL=launch-app.js.map